import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { CollectionCategoryPage } from '$/pages/DashboardPages/pages/Collection/pages/CollectionCategoryPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const ColorCollectionsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/collections/colors',
  component: () => <CollectionCategoryPage materialType='color_tint' />,
  loader: () => {
    useCollectionStore.setState({
      activeType: 'color_tint',
      selectedViewMode: 'grid',
    });
    useMaterialSearchStore.setState({
      dropdownVisible: false,
    });
  },
  onLeave: () => {
    useCollectionStore.getState().resetAppliedFilter();
  },
  staleTime: 0,
});
